export default __webpack_public_path__ + "static/media/7.9437ee4d.jpg";